import React from 'react';

export type SystemConfigTabId =
  | 'personnel'
  | 'vehicules'
  | 'competences'
  | 'fonctions-armement'
  | 'batiments'
  | 'partenaires'
  | 'categories-mission'
  | 'categories-spe';

interface SystemConfigTabsNavProps {
  activeTab: SystemConfigTabId;
  setActiveTab: (id: SystemConfigTabId) => void;
  t: (key: string) => string;
}

const TABS: { id: SystemConfigTabId; labelKey: string }[] = [
  { id: 'personnel', labelKey: 'tabs.personnel' },
  { id: 'vehicules', labelKey: 'tabs.vehicules' },
  { id: 'competences', labelKey: 'tabs.competences' },
  { id: 'fonctions-armement', labelKey: 'tabs.fonctionsArmement' },
  { id: 'batiments', labelKey: 'tabs.batiments' },
  { id: 'partenaires', labelKey: 'tabs.partenaires' },
  { id: 'categories-mission', labelKey: 'tabs.categoriesMission' },
  { id: 'categories-spe', labelKey: 'tabs.categoriesSpe' },
];

/** Barre d'onglets extraite de SystemConfiguration.tsx. */
const SystemConfigTabsNav: React.FC<SystemConfigTabsNavProps> = ({
  activeTab,
  setActiveTab,
  t,
}) => (
  <div className="flex border-b border-gray-700 mb-6">
    {TABS.map((tab) => (
      <button
        key={tab.id}
        onClick={() => setActiveTab(tab.id)}
        className={`px-6 py-3 text-sm font-medium transition-colors relative ${
          activeTab === tab.id
            ? 'text-blue-400 border-b-2 border-blue-400'
            : 'text-gray-400 hover:text-white'
        }`}
      >
        {t(tab.labelKey)}
      </button>
    ))}
  </div>
);

export default SystemConfigTabsNav;
